import { Flex, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';

import { useContentGridColumns } from '../../hooks/useContentGridColumns';
import { AdditionalServiceCardAirwallex } from '../AdditionalServiceCardAirwallex/AdditionalServiceCardAirwallex';
import { AdditionalServiceCardDext } from '../AdditionalServiceCardDext/AdditionalServiceCardDext';
import { messages } from './AdditionalServicesSection.messages';
import { AdditionalServicesSectionProps } from './AdditionalServicesSection.types';

export const AdditionalServicesSection = memo<AdditionalServicesSectionProps>((props) => {
    const { company } = props;

    const { columns } = useContentGridColumns();

    const isNetSuite = company.integration?.integrationType === domain.IntegrationType.NetSuite;
    const isDear = company.integration?.integrationType === domain.IntegrationType.Dear;

    const isAirwallexVisible = company.flags.isAirwallexPaymentAvailable;

    if (!company.integration || isNetSuite || isDear) {
        return null;
    }

    return (
        <>
            <Text font='headline' fontSize='xxsmall' spacing='16 0'>
                {messages.additionalServices}
            </Text>

            <Flex container spacing='16'>
                <Flex size={columns === 2 ? 12 : 24}>
                    <AdditionalServiceCardDext company={company} />
                </Flex>

                {isAirwallexVisible && (
                    <Flex size={columns === 2 ? 12 : 24}>
                        <AdditionalServiceCardAirwallex company={company} />
                    </Flex>
                )}
            </Flex>
        </>
    );
});

AdditionalServicesSection.displayName = 'AdditionalServicesSection';
